import { Breadcrumbs, Link, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

export default function PageHeader(props) {
  const params = useParams();
  const { id, title, pageConfig, logo } = props;
  let paths = window.location.pathname.split('/').filter((path) => path !== '');
  paths = paths.slice(0, Object.keys(params).length ? -Object.keys(params).length : paths.length);

  if (props.subPageId) {
    paths.push(props.subPageId);
  }

  return (
    <React.Fragment>
      {logo ? (
        <img src={logo} />
      ) : (
        <Typography id={`${id}__text_title`} component="h2">
          {title}
        </Typography>
      )}

      <Breadcrumbs className="myOdu__breadcrumbs" id={`${id}__breadCrumbs`} aria-label="breadcrumb">
        <Link href="/" id={`${id}__link_dashboard`}>
          Dashboard
        </Link>
        {paths.map((path, index, array) => {
          const pageDetails = pageConfig[path];
          if (!pageDetails) {
            return null;
          }
          if (index === array.length - 1) {
            return (
              <Typography key={index} id={`${id}__text_${pageDetails.id}`}>
                {pageDetails.title}
              </Typography>
            );
          }

          return (
            <Link key={index} href={`/${pageDetails.url}`} id={`${id}__link_${pageDetails.id}`}>
              {pageDetails.title}
            </Link>
          );
        })}
      </Breadcrumbs>
    </React.Fragment>
  );
}
